import AbstractEntity from "../AbstractEntity";

export default class Company extends AbstractEntity {
    static STATUS_U1P = 0;
    static STATUS_U1 = 1;
    static STATUS_U2 = 2;
    static STATUS_U4 = 3;
    static STATUS_U3 = 4;
    static STATUS_NETWORK_HEAD = 5;

    _id;
    _name;
    _email;
    _apeCode;
    _siret;
    _billingId;
    _phoneMobile;
    _phoneSecretary;
    _status;
    _subjectVat;
    _prospect;
    _wantSuggestionCall;
    _wantSuggestionMail;
    _wantSuggestionSms;
    _comment;
    _legalDocumentUpToDate;
    _delegatedAccountId;
    _createdAt;
    _artisansId;
    _worksId;
    _secondaryWorksId;
    _entrepreneurId;
    _companyAddressId;
    _legalDocumentsId;
    _calendarId;
    _companyCommentsId;

    getId() {
        return this._id;
    }

    getName() {
        return this._name;
    }

    getEmail() {
        return this._email;
    }

    getApeCode() {
        return this._apeCode;
    }

    getSiret() {
        return this._siret;
    }

    getBillingId() {
        return this._billingId;
    }

    getPhoneMobile() {
        return this._phoneMobile;
    }

    getPhoneSecretary() {
        return this._phoneSecretary;
    }

    getStatus() {
        return this._status;
    }

    isSubjectVat() {
        return this._subjectVat;
    }

    isProspect() {
        return this._prospect;
    }

    isWantSuggestionCall() {
        return this._wantSuggestionCall;
    }

    isWantSuggestionMail() {
        return this._wantSuggestionMail;
    }

    isWantSuggestionSms() {
        return this._wantSuggestionSms;
    }

    getComment() {
        return this._comment;
    }

    isLegalDocumentUpToDate() {
        return this._legalDocumentUpToDate;
    }

    getDelegatedAccountId() {
        return this._delegatedAccountId;
    }

    getCreatedAt() {
        return this._createdAt;
    }

    getArtisansId() {
        return this._artisansId;
    }

    getWorksId() {
        return this._worksId;
    }

    getSecondaryWorksId() {
        return this._secondaryWorksId;
    }

    getEntrepreneurId() {
        return this._entrepreneurId;
    }

    getCompanyAddressId() {
        return this._companyAddressId;
    }

    getLegalDocumentsId() {
        return this._legalDocumentsId;
    }

    getCalendarId() {
        return this._calendarId;
    }

    getCompanyCommentsId() {
        return this._companyCommentsId;
    }

    getClassName() {
        return "company";
    }

}